import FollowUpsIndex from './Index.vue';

export const routes = [
  {
    path: 'follow-ups',
    name: 'follow_up_dashboard',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: FollowUpsIndex,
  },
];
